import React, { useEffect, useState } from 'react';
import { Button, IconButton, Tooltip, Typography, Box, FormHelperText } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import TimelineIcon from '@material-ui/icons/Timeline';
import { AddIcon } from '@material-ui/data-grid';
import { Link } from 'react-router-dom';
import EditIcon from "@material-ui/icons/Edit";
import CloudDownload from '@material-ui/icons/CloudDownload';
import moment from 'moment';
import Visibility from "@material-ui/icons/Visibility"
import useStyles from './MyPatients.style';
import { Alert } from '@material-ui/lab';
import { CSVLink } from "react-csv";
import Cookies from 'universal-cookie';
import CustomNoRowsOverlay from '../../../components/CustomNoRowsOverlay';
import '../../../App.css';
import validator from 'validator';
import UserDataGrid from '../../../components/UserDataGrid';
import { RepLIProviderTextField } from '../../../components';


const cookies = new Cookies();

const MyPatients = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [data, setData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFromDateValid, setFromDateValid] = useState(true);
    const [isFromDateError, setFromDateError] = useState(false);
    const [isToDateValid, setToDateValid] = useState(true);
    const [isToDateError, setToDateError] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const columns = [
        { field: 'fullName', headerName: t('common.table.header.name'), width: 230 },
        { field: 'email', headerName: t('common.table.header.email'), width: 230 },
        {
            field: 'dateOfBirth', headerName: t('common.table.header.dob'), width: 230,
            valueFormatter: params => params.value ? new Date(params.value).toLocaleDateString() : '--'
        },
        { field: 'organization', headerName: t('common.table.header.organization'), width: 230 },
        { field: 'department', headerName: t('common.table.header.department'), width: 230 },
        {
            field: 'createdAt',
            headerName: t('common.table.header.createdAt'),
            width: 230,
            valueFormatter: params => new Date(params.value).toLocaleDateString()
        },
        {
            field: 'id',
            headerName: ' ',
            renderCell: (params) => (
                <>
                    <Tooltip arrow title="View">
                        <IconButton
                            aria-label="RepLI"
                            color="primary"
                            component={Link}
                            to={`/provider/patient/profile/${params.value}`}
                        >
                            <Visibility />
                        </IconButton>
                    </Tooltip>
                    <Tooltip arrow title={t('common.table.action.edit')}>
                        <IconButton
                            aria-label={t('common.table.action.edit')}
                            color="primary"
                            component={Link}
                            to={`/provider/patient/${params.value}`}
                        >
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip arrow title="RepLI">
                        <IconButton
                            aria-label="RepLI"
                            color="primary"
                            component={Link}
                            to={`/provider/repli/${params.value}`}
                        >
                            <TimelineIcon />
                        </IconButton>
                    </Tooltip>
                </>
            ),
            width: 160,
            align: 'center'
        },
    ];





    const validateFromDate = (value) => {
        if (validator.isDate(value)) {
            if (toDate !== "" && toDate !== null) {
                if (new Date(value) <= new Date(toDate)) {
                    setFromDate(value);
                    setFromDateError(false);
                    setFromDateValid(true);
                    setToDateError(false);
                    setToDateValid(true);
                    setRefreshKey(oldKey => oldKey + 1);
                }
                else {
                    setFromDate(value);
                    setFromDateError(true);
                    setFromDateValid(true);
                }
            } else {
                setFromDate(value);
                setFromDateError(false);
                setFromDateValid(true);
            }
        } else {
            setFromDate(null);
            setFromDateError(false);
            setFromDateValid(false);
        }
    }



    const validateToDate = (value) => {
        if (validator.isDate(value)) {
            if (fromDate !== "" && new Date(value) >= new Date(fromDate)) {
                setToDate(value);
                setToDateError(false);
                setToDateValid(true);
                setFromDateError(false);
                setFromDateValid(true);
                setRefreshKey(oldKey => oldKey + 1);
            }
            else {
                setToDate(null);
                setToDateError(true);
                setToDateValid(true);
            }
        } else {
            setToDate(null);
            setToDateError(false);
            setToDateValid(false);
        }
    }




    useEffect(() => {
        if (isFromDateValid && isToDateValid) {
            setLoading(true);
            const getPatients = async () => {
                setLoading(true);
                try {
                    setLoading(true);
                    var date = new Date();
                    var toDt = new Date();
                    var fromDt = new Date(date.setMonth(date.getMonth() - 1));

                    let response;

                    if (toDate == "" && fromDate == "") {
                        setFromDate(moment(fromDt).utc().format('YYYY-MM-DD'));
                        setToDate(moment(toDt).utc().format('YYYY-MM-DD'));

                        response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_MYPATIENTS}/${toDt}/${fromDt}`, {
                            headers: {
                                'X-ACCESS-TOKEN': cookies.get('token')
                            }
                        });
                        setLoading(false);
                    }

                    else {
                        response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_MYPATIENTS}/${toDate}/${fromDate}`, {
                            headers: {
                                'X-ACCESS-TOKEN': cookies.get('token')
                            }
                        });
                        setLoading(false);
                    }

                    let json = await response.json();
                    if (!response.ok) {
                        // setError(json.message);
                        setToDateError(true)
                        setFromDateError(true)
                        return;
                    };
                    setRows(json.filter(x => x.user !== null).map((patient, index) => {
                        return {
                            id: patient.user._id,
                            fullName: `${patient.user.lastName}, ${patient.user.firstName}`,
                            email: patient.user.email,
                            dateOfBirth: patient.dateOfBirth,
                            createdAt: patient.createdAt,
                            organization: patient.organizations,
                            department: patient.user.department === "undefined" ? '' : patient.user.department
                        }
                    }));
                    const mappedData = json.filter(x => x.user !== null).map((patient, index) => {
                        return {
                            Email: patient.user.email,
                            FirstName: patient.user.firstName,
                            LastName: patient.user.lastName,
                            Organization: patient.organizations,
                            department: patient.user.department === "undefined" ? '' : patient.user.department,
                            DateOfBirth: moment(patient.dateOfBirth).format('YYYY-MM-DD'),
                            Race: patient.races,
                            RaceSelfDescribe: patient.raceSelfDescribe,
                            MaritalStatus: patient.relationshipStatus,
                            DateofRepliCreated: patient.createdAt,
                            Age: new Date(Date.now()).getFullYear() - new Date(patient.dateOfBirth).getFullYear(),
                            DesiredChildren: patient.desiredChildrenQty,
                            BiologicalChildren: patient.pregnancies.map(item => item.liveBirthQty).reduce((prev, curr) => prev + curr, 0),
                            PlacedAdoptionChildren: patient.pregnancies.map(item => item.placedAdoptionQty).reduce((prev, curr) => prev + curr, 0),
                            StillBirthChildren: patient.pregnancies.map(item => item.stillbirthQty).reduce((prev, curr) => prev + curr, 0),
                            ChildrenLoss: patient.childrenLoss.map(item => item.childrenQty ? item.childrenQty : 0).reduce((prev, curr) => prev + curr, 0),
                            Miscarriage: patient.pregnancies.filter(x => x.outcome.includes("Miscarriage")).length,
                            Abortion: patient.pregnancies.filter(x => x.outcome.includes("Abortion")).length,
                            Adoptions: patient.adoptions.map(item => item.childrenQty).reduce((prev, curr) => prev + curr, 0),
                            Stepchildren: patient.stepchildren.map(item => item.stepchildrenQty).reduce((prev, curr) => prev + curr, 0),
                            TotalChildren: patient.currentChildrenQty,
                            ChildbearingYearFrame: `${patient.childbearingYearFrame[0]}-${patient.childbearingYearFrame[1]}`,
                            FirstPeriodAge: patient.firstPeriodAge,
                            SexualDebutAge: patient.sexuallyActiveAge,
                            MenopauseAge: patient.menopauseAge,
                            Gender: patient.gender,
                            GenderIdentity: patient.genderIdentity,
                            GenderIdentitySelfDescribe: patient.genderIdentitySelfDescribe,
                            SexualPreferences: patient.sexualPreferences,
                            SexualPreferenceSelfDescribe: patient.sexualPreferenceSelfDescribe,
                            AnyCancerDiagnosis: patient.anyCancerDiagnosis,
                            AnyWaitingCancerDiagnosis: patient.anyWaitingCancerDiagnosis,
                            CurrentSiteOfCancer: patient.currentSiteOfCancer,
                            PendingCancerDiagnosis: patient.pendingCancerDiagnosis === "undefined" ? "" : patient.pendingCancerDiagnosis,
                            OtherPendingCancerDiagnosis: patient.otherPendingCancerDiagnosis === "undefined" ? "" : patient.otherPendingCancerDiagnosis,
                            Contraception: patient.contraception.length,
                            FertilityPreservation: patient.fertilityPreservation.length,
                            FertilityTreatment: patient.fertilityTreatment.length,
                            Cancers: patient.cancers.length,
                            FPQ: patient.desiredChildrenQty / patient.currentChildrenQty
                        }
                    });

                    setData(mappedData);
                    setExportData(mappedData);
                    setLoading(false);
                }
                catch (error) {
                    setLoading(false);
                    console.log(error);
                    setError(`${t('module.provider.patientAssociation.message.patientDataLoadFailure')}. ${t('common.message.error.seeLog')}.`);
                } finally {
                    setLoading(false);
                }
            };

            getPatients();
        }
    }, [isFromDateValid, isToDateValid, t, refreshKey, toDate, fromDate]);





    const onFilterModelChange = (event) => {
        let filteredRows = [...rows];

        event.filterModel.items.forEach(filter => {
            const { columnField, operatorValue, value } = filter;

            filteredRows = filteredRows.filter(row => {
                const cellValue = row[columnField];
                switch (operatorValue) {
                    case 'contains':
                        return cellValue && cellValue.toString().toLowerCase().includes(value && value.toLowerCase());
                    case 'equals':
                        return cellValue && cellValue.toString().toLowerCase() === value.toLowerCase();
                    case 'startsWith':
                        return cellValue && cellValue.toString().toLowerCase().startsWith(value.toLowerCase());
                    case 'endsWith':
                        return cellValue && cellValue.toString().toLowerCase().endsWith(value.toLowerCase());
                    default:
                        return true;
                }
            });
        });

        let filteredExportingData = data.filter(row => {
            return filteredRows.some(filteredRow => filteredRow.email === row.Email);
        });

        setExportData(filteredExportingData);
    };






    if (error) return <Alert severity="error">{error}</Alert>

    return (
        <>
            <Typography variant="h4" className={classes.title}>{t('module.provider.mypatients.title')}</Typography>
            <Box style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                <Box>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.addButton}
                        component={Link}
                        to="/provider/patient/add"
                        startIcon={<AddIcon />}
                    >
                        {t('common.form.button.addNew')}
                    </Button>
                    {exportData.length > 0 && <Button
                        variant="contained"
                        color="primary"
                        className={classes.exportButton}
                        startIcon={<CloudDownload />}
                    >
                        <CSVLink className={classes.csvExportBtn} data={exportData}
                            filename={"patients.csv"}>Export</CSVLink>
                    </Button>}
                </Box>
                <Box>
                    <Button
                        variant="contained"
                        color="primary"
                        href="https://paptrack-prod.azurewebsites.net/provider/provider/mypatients"
                        startIcon={<Visibility />}
                    >
                        {t("common.form.button.PaptrakPatientpreview")}
                    </Button>
                </Box>
            </Box>



            <Box style={{ width: "100%", backgroundColor: "#eff3f6" }}>
                <Box style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", padding: "10px 16px", height: "100px" }}>
                    <Box style={{ width: "40%" }}>
                        <Box style={{ display: "flex" }}>
                            <Typography className={classes.userName}>
                                My Patients
                            </Typography>
                        </Box>
                        <Box><Typography>{moment(fromDate).format("MMM DD, YYYY")} - {moment(toDate).format("MMM DD, YYYY")}</Typography></Box>
                    </Box>
                    <Box style={{ width: "60%", display: "flex", alignItems: "center" }}>
                        <Box style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between" }}>
                            <Box style={{ wordWrap: "break-word", width: "30%", justifyContent: "center" }}>
                                <Typography className={classes.userName}>
                                    Period of time
                                </Typography>
                            </Box>
                            <Box style={{ width: "70%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Box style={{ width: "40%", height: "100px" }}>
                                    <RepLIProviderTextField
                                        style={{ marginBottom: 0 }}
                                        label={t('module.provider.dashboard.dateFilters.fromDate')}
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => validateFromDate(e.target.value)}
                                        InputProps={{ inputProps: { max: moment(new Date()).format('YYYY-MM-DD') } }}
                                        value={fromDate}
                                        loading={loading}
                                    />
                                    {isFromDateError &&
                                        <FormHelperText error>
                                            {t('module.provider.dashboard.errorMessage.fromDate')}
                                        </FormHelperText>
                                    }
                                    {!isFromDateValid &&
                                        <FormHelperText error>
                                            {t('module.provider.dashboard.errorMessage.fromDateReq')}
                                        </FormHelperText>
                                    }
                                </Box>
                                <Box style={{ wordWrap: "break-word", justifyContent: "center" }}>
                                    <Typography >
                                        to
                                    </Typography>
                                </Box>
                                <Box style={{ width: "40%", height: "100px" }}>
                                    <RepLIProviderTextField
                                        style={{ marginBottom: 0 }}
                                        label={t('module.provider.dashboard.dateFilters.toDate')}
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => validateToDate(e.target.value)}
                                        InputProps={{ inputProps: { max: moment(new Date()).format('YYYY-MM-DD'), min: moment(fromDate).format('YYYY-MM-DD') } }}
                                        value={toDate}
                                        loading={loading}
                                    />
                                    {isToDateError &&
                                        <FormHelperText error>
                                            {t('module.provider.dashboard.errorMessage.toDate')}
                                        </FormHelperText>
                                    }
                                    {!isToDateValid &&
                                        <FormHelperText error>
                                            {t('module.provider.dashboard.errorMessage.toDateReq')}
                                        </FormHelperText>
                                    }
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>


            <UserDataGrid
                onFilterModelChange={onFilterModelChange}
                columns={columns}
                rows={rows}
                loading={loading}
                components={{
                    noRowsOverlay: CustomNoRowsOverlay,
                }}
            />
        </>
    );
};

export default MyPatients;